import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraHubGrid } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
const planes = [
    {
        plane: 'MARKET',
        label: 'Market',
        tone: 'info'
    },
    {
        plane: 'GROWTH',
        label: 'Growth',
        tone: 'success'
    },
    {
        plane: 'DELIVERY',
        label: 'Delivery',
        tone: 'teal'
    },
    {
        plane: 'VEHICLES',
        label: 'Vehicles',
        tone: 'neutral'
    }
];
export function WhereTheyShowUp({ cards }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Where they show up"
            }),
            /*#__PURE__*/ _jsx(SpecraHubGrid, {
                columns: 4,
                renderLink: renderRouterLink,
                getItemTestId: ()=>Testids.registryGovOrg.showUpCard,
                items: planes.map((p)=>{
                    const card = cards.find((c)=>c.plane === p.plane);
                    return {
                        id: p.plane,
                        title: card?.title || 'Nothing linked yet',
                        description: card?.summary || undefined,
                        eyebrow: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: p.tone,
                            children: p.label
                        }),
                        href: card?.primary ? registryHref(card.primary) ?? undefined : undefined
                    };
                })
            }),
            cards.length === 0 && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Nothing you can see links to this office yet."
            })
        ]
    });
}
